import * as React from 'react';

export default class noComments extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
    

<svg className= {this.props.className} width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink">
  
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Icons-/-16-x-16-/-Light-/-Logs" stroke="#666666">
          <g id="Diaries">
              <g id="Group-12" transform="translate(1.000000, 1.000000)">
                  <path d="M9.84371111,10.3157895 C9.83671111,9.80805614 9.82971111,9.30032281 9.82426667,8.79337544" id="Stroke-2"></path>
                  <path d="M13.7326778,9.98419088 C13.7326778,12.1746751 11.9749,13.9509558 9.80723333,13.9509558 C7.63956667,13.9509558 5.88178889,12.1746751 5.88178889,9.98419088 C5.88178889,7.79370667 7.63956667,6.01742596 9.80723333,6.01742596 C11.9749,6.01742596 13.7326778,7.79370667 13.7326778,9.98419088 Z" id="Stroke-4"></path>
                  <path d="M7.14583333,12.7657993 L0.582944444,12.7657993 C0.368277778,12.7657993 0.194055556,12.5897432 0.194055556,12.3728168 L0.194055556,0.554262456 C0.194055556,0.33733614 0.368277778,0.16128 0.582944444,0.16128 L12.1166111,0.16128 C12.3312778,0.16128 12.5055,0.33733614 12.5055,0.554262456 L12.5055,6.88520982" id="Stroke-6"></path>
                  <path d="M3.48825556,3.42169825 C3.85458889,3.17569123 4.25436667,2.98234386 4.67358889,2.84872982 C4.71714444,4.62029474 4.64247778,6.4736 4.68603333,8.24437895" id="Stroke-8"></path>
                  <path d="M7.40102222,3.42169825 C7.76735556,3.17569123 8.16713333,2.98234386 8.58557778,2.84872982 C8.62991111,4.62029474 8.54357778,3.77616842 8.58713333,5.54694737" id="Stroke-10"></path>
              </g>
          </g>
      </g>
  </g>
</svg>


    );
  }
}
